export default {
	path: '/user',
	redirect: '/user',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'userHome',
			component: () => import('@/views/mng/User'),
		},
	],
};
